import Layout from '@/layout/layout'

const orderImageConfig = {
  path: '/orderImageConfig',
  component: Layout,
  redirect: 'noRedirect',
  name: '订单图片处理配置',
  children: [
    {
      path: 'imgoRderManagement',
      component: () => import('@/views/orderImageConfig/imgoRderManagement/index'),
      name: '订单图片处理配置',
      meta: { title: '订单图片处理配置', noCache: true }
    },
  ]
}

export default orderImageConfig
